import { useSelectedSite } from '@/helpers/auth'
import actions from './actions'
import mutations from './mutations'

let state = {
    all: [],
    currentId: useSelectedSite(),
    current: null,
    markets: []
}

const ACTIONS = {
    GET: 'sites/get',
    GET_ALL: 'sites/getAll',
    GET_MARKETS: 'sites/getMarkets',
}

export default {
    namespaced: true,
    state,
    actions,
    mutations
}

export { ACTIONS as actions }